const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Main Comments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('MainComments', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/maincomments/:subresource/:method/:userid', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST'},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    like: {params: {subresource: '', method: 'like'}, method: 'POST', isArray: false},
    unlike: {params: {subresource: '', method: 'unlike'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE'}
  });

}]);

